<script setup lang="ts">
import Axios from 'axios';
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons';
import {
    faBadgeDollar,
    faTag,
    faWandMagicSparkles,
} from '@fortawesome/pro-regular-svg-icons';
import DownloadAppButtons from './DownloadAppButtons.vue';

const mobile = ref('');
const sending = ref(false);
const badges = [
    {
        content: 'تخفیف‌های اختصاصی اپلیکیشن',
        icon: faTag,
    },
    {
        content: 'راحت‌تر برای پرسفرها',
        icon: faWandMagicSparkles,
    },
    {
        content: 'امکانات بیشتر برای سفر به‌صرفه',
        icon: faBadgeDollar,
    },
];
const sendSMS = async () => {
    if (!/09\d{9}/.test(convertPersianNumbers(mobile.value))) {
        swal({
            text: 'لطفا شماره تلفن را به‌صورت 09xxxxxxxxx وارد کنید.',
            icon: 'warning',
            confirmButtonText: 'باشه',
        });
        return;
    }
    sending.value = true;
    try {
        await Axios.post(
            `${useBaseUrls().content}/sms/get_app/send?to=${mobile.value}`,
            undefined,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        swal({
            text: 'پیامک با موفقیت ارسال شد!',
            icon: 'success',
            confirmButtonText: 'باشه',
        });
        sending.value = false;
        mobile.value = '';
    } catch (error) {
        handleException(error);
        sending.value = false;
    }
};
</script>
<template>
    <div id="mr-app" class="download-app-container">
        <div class="download-app-wrapper container">
            <div class="ios">
                <mr-lazy-img
                    src="/img/download-app/iPhone_X.svg"
                    alt="اپلیکیشن مِستربلیط"
                    :width="250"
                    :height="270"
                />
            </div>
            <div class="main-container">
                <mr-typography size="display3" weight="700">
                    ساده‌تر با اپلیکیشن مِستربلیط
                </mr-typography>
                <div class="form">
                    <mr-input
                        v-model="mobile"
                        :icon="faMobileAlt"
                        placeholder="شماره موبایل"
                        required
                        hide-description
                        @submit="sendSMS"
                    />
                    <mr-button :loading="sending" class="send" @click="sendSMS">
                        ارسال لینک دانلود
                    </mr-button>
                </div>
                <div class="badges">
                    <div
                        v-for="badge in badges"
                        :key="badge.content"
                        class="badge"
                    >
                        <mr-icon :icon="badge.icon" color="var(--blue-500)" />
                        <mr-typography
                            size="large"
                            weight="500"
                            color="var(--blue-500)"
                        >
                            {{ badge.content }}
                        </mr-typography>
                    </div>
                </div>
            </div>
            <div class="QR-code-container">
                <mr-lazy-img
                    src="/img/download-app/QR.svg"
                    alt="QR-code"
                    :width="140"
                    :height="140"
                />
                <mr-typography size="medium" weight="700" white-space="nowrap">
                    یا برای دانلود اسکن کنید.
                </mr-typography>
            </div>
            <div class="mobile-iphone">
                <mr-lazy-img
                    class="iphone"
                    src="/img/download-app/iPhone_XM.svg"
                />
                <DownloadAppButtons />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.download-app-container {
    background-color: usePalette($p-cool-gray, $p-100);
    width: 100%;
    padding-block: 24px;
    padding-inline: 12px;
    @include mobile-only($app-tablet-max-width) {
        padding-block: 12px;
    }
    .download-app-wrapper {
        padding: 30px 40px 0 40px;
        display: flex;
        justify-content: space-between;
        background-color: white;
        border-radius: 12px;
        margin: 0 auto;
        @include shadow();
        @include mobile-only($app-tablet-max-width) {
            padding: 20px 20px 0 20px;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            @include f-gap(20px, column);
        }

        .ios {
            display: flex;
            @include mobile-only($app-tablet-max-width) {
                display: none;
            }
        }

        .main-container {
            padding-top: 10px;
            display: flex;
            flex-direction: column;
            flex-basis: 40%;
            max-width: 40%;
            @include f-gap(20px, column);
            @include mobile-only($app-tablet-max-width) {
                flex-basis: 100%;
                max-width: 100%;
                align-items: center;
            }
            .form {
                display: flex;
                @include f-gap(8px);
                @include mobile-only($app-tablet-max-width) {
                    display: none;
                }

                .send {
                    white-space: nowrap;
                    flex-shrink: 0;
                }
            }

            .badges {
                display: flex;
                flex-wrap: wrap;
                @include f-gap(20px, $flex-wrap: wrap, $size-cross: 8px);
                @include mobile-only($app-tablet-max-width) {
                    justify-content: center;
                    @include f-gap(20px, $flex-wrap: wrap, $size-cross: 4px);
                }

                .badge {
                    display: flex;
                    @include f-gap(8px);
                    align-items: center;
                }
            }
        }

        .QR-code-container {
            padding-top: 21px;
            padding-inline: 40px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            @include mobile-only($app-tablet-max-width) {
                display: none;
            }

            img {
                width: 140px;
                height: 140px;
            }
        }

        .mobile-iphone {
            position: relative;
            display: none;

            .iphone {
                position: absolute;
                inset: 0 0 0 0;
                z-index: 5;
            }
            .downloads {
                z-index: 10;
            }
            @include mobile-only($app-tablet-max-width) {
                display: flex;
                justify-content: center;
                width: 270px;
                height: 270px;
                padding-top: 60px;
            }
        }
    }
}
</style>
